function modifyHeader(){
  /*
      Used for quick ui bug fix for veretically streched header in iphone SE 
  */
      console.log('in');
  let navHeader = document.querySelector('nav.breadcrumbs');
  if(window.innerWidth < 380 &&  ( navigator.userAgent.indexOf('Mac') != -1) &&navHeader ){
    console.log('in');
     setTimeout( () => { navHeader.classList.add('header__vertical') } ,1500 ) ;
  }
}

window.addEventListener('DOMContentLoaded' ,modifyHeader);